import { useFetchOrganizationCoworkers } from "@core/features/organization";
import { Loader } from "@themes/pollinator/ui/Loader";
import { CoworkersTable } from "./CoworkersTable";

export type Props = {
  organizationId: number;
};

/**
 * Container for CoworkersTable.
 * Fetches organization coworkers (active admins + pending invitations).
 */
export function CoworkersTableContainer({ organizationId }: Props) {
  const { data: coworkers, isLoading } = useFetchOrganizationCoworkers({
    organizationId,
    enabled: !!organizationId,
  });

  if (isLoading) {
    return <Loader />;
  }

  if (!coworkers) {
    return null;
  }

  return <CoworkersTable teamMembers={coworkers} />;
}

export default CoworkersTableContainer;
